import ToggleSwitch from 'core/elements/ToggleSwitch'
import React from 'react'

const SystemUsersToggle = ({ checked, toggle }) => {
  return <ToggleSwitch active={checked} onClick={toggle} label="Show System Users" />
}

export default SystemUsersToggle
